import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Trazabilidad/getLotes`, method: 'POST', body: values, token: token})
}